var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"table-row",class:{ loading: _vm.isLoading },on:{"click":function($event){return _vm.handleClick($event)}}},[_vm._t("default",null,{"hidden":_vm.hidden,"filter":_vm.filter,"sort":_vm.sort})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }